import React from "react";
import Styled, { CustomModal, LineBreak } from "./styles";

const getCategory = rating =>
  rating.name === "AAA" || rating.name === "BBB"
    ? "Investment Grade"
    : "High Yield";

const getDebtToCapital = (rating, ratings) => {
  const from = (rating.debt_to_capital * 100).toFixed(2);
  const index = ratings.findIndex(i => i.name === rating.name);

  if (index + 1 >= ratings.length) {
    return `${from}% or more`;
  }

  const to = ((ratings[index + 1].debt_to_capital - 0.0001) * 100).toFixed(2);

  return `${from}% to ${to}%`;
};

const ModalExhibit6 = ({ ratings, goBack }) => (
  <CustomModal goBack={goBack}>
    <b>EXHIBIT 6 - Rating Agency - Corporate Credit Ratings & Spreads</b>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Rating</th>
          <th>Category</th>
          <th>Debt to Capital</th>
          <th>Corporate Credit Spreads (100 bps = 1%)</th>
        </tr>
        {ratings.map(rating => (
          <tr key={rating.name}>
            <td>{rating.name}</td>
            <td>{getCategory(rating)}</td>
            <td>{getDebtToCapital(rating, ratings)}</td>
            <td>{rating.credit_spread * 10000} bps</td>
          </tr>
        ))}
      </tbody>
    </Styled.ModalTable>
  </CustomModal>
);

export default ModalExhibit6;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit6.js